import { render } from "./FellowshipForm.vue?vue&type=template&id=daf51eea&scoped=true"
import script from "./FellowshipForm.vue?vue&type=script&lang=js"
export * from "./FellowshipForm.vue?vue&type=script&lang=js"

import "./FellowshipForm.vue?vue&type=style&index=0&id=daf51eea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf51eea"]])

export default __exports__